/*
 * 接口统一集成模块
 */
import * as authc from './moudules/authc'

// 默认全部导出
export default {
  authc
}



// WEBPACK FOOTER //
// ./src/http/api.js